import { useEffect, useState } from 'react';

export function useJsonResource<T>(urlVersion: string | undefined, resourcePath: string) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<T | null>(null);

  const version = urlVersion ?? '3.0.0';

  useEffect(() => {
    async function loadResource() {
      if (!version) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // Fetch from /api/{version}/{resourcePath}
        const response = await fetch(`/api/${version}/${resourcePath}`);
        if (!response.ok) {
          throw new Error(`Failed to load resource: ${response.status} ${response.statusText}`);
        }

        const jsonData = await response.json();
        setData(jsonData);
      } catch (err) {
        console.error(`Failed to load ${resourcePath} for version ${version}:`, err);
        setError(`Failed to load resource for version ${version}`);
      } finally {
        setLoading(false);
      }
    }

    loadResource();
  }, [version, resourcePath]);

  return { loading, error, data };
}

